<template>
  <div id="mku_front">
    <vue-progress-bar></vue-progress-bar>
    <header-component/>
    <transition name="page" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <footer-component/>
  </div>
</template>

<script>
import HeaderComponent from 'components/HeaderComponent.vue'
import FooterComponent from 'components/FooterComponent.vue'

export default {
  components: {
    FooterComponent,
    HeaderComponent
  },
  metaInfo () {
    return this.$seo('common', '', '', '', '', '', '')
  },
  created () {
    this.$Progress.start()
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress
        this.$Progress.parseMeta(meta)
      }
      this.$Progress.start()
      next()
    })
    this.$router.afterEach((to, from) => {
      this.$Progress.finish()
    })
  },
  mounted () {
    this.$Progress.finish()
  }
}
</script>

<style lang="stylus">
@import "styles/index.styl"
</style>
